export function NotificationSuccessIconSvg() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_9898_5616)">
        <path fillRule="evenodd" clipRule="evenodd" d="M10 15.5C6.70017 15.5 5.05025 15.5 4.02513 14.4749C3 13.4497 3 11.7998 3 8.5C3 5.20017 3 3.55025 4.02513 2.52513C5.05025 1.5 6.70017 1.5 10 1.5C13.2998 1.5 14.9497 1.5 15.9749 2.52513C17 3.55025 17 5.20017 17 8.5C17 11.7998 17 13.4497 15.9749 14.4749C14.9497 15.5 13.2998 15.5 10 15.5ZM12.8212 6.37877C13.0263 6.58379 13.0263 6.91621 12.8212 7.12123L9.32123 10.6212C9.11621 10.8263 8.78379 10.8263 8.57877 10.6212L7.17877 9.22123C6.97374 9.01621 6.97374 8.68379 7.17877 8.47877C7.38379 8.27374 7.71621 8.27374 7.92123 8.47877L8.95 9.50754L12.0788 6.37877C12.2838 6.17374 12.6162 6.17374 12.8212 6.37877Z" fill="var(--p-green-700)" />
      </g>
      <defs>
        <filter id="filter0_di_9898_5616" x="0" y="0.5" width="20" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_9898_5616" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9898_5616" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9898_5616" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_9898_5616" />
        </filter>
      </defs>
    </svg>
  );
}
